<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <producto-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ProductoCrud from "./ProductoCrud";
    export default {
        name: "Producto",
        components: {ProductoCrud}
    }
</script>

<style scoped>

</style>

